"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const Add_1 = require("@material-ui/icons/Add");
const Remove_1 = require("@material-ui/icons/Remove");
const react_i18next_1 = require("react-i18next");
const styles = () => (0, core_1.createStyles)({
    content: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    }
});
const ShoppingCartItemQuantity = ({ shoppingCartItem, onAddItem, onRemoveItem, classes }) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.content }, { children: [(0, jsx_runtime_1.jsx)(core_1.IconButton, Object.assign({ color: 'secondary', onClick: onRemoveItem ? onRemoveItem.bind(this, shoppingCartItem) : undefined, "aria-label": "remove" }, { children: (0, jsx_runtime_1.jsx)(Remove_1.default, {}) })), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body2", color: "textPrimary" }, { children: shoppingCartItem.quantity })), (0, jsx_runtime_1.jsx)(core_1.IconButton, Object.assign({ color: 'secondary', onClick: onAddItem ? onAddItem.bind(this, shoppingCartItem) : undefined, "aria-label": "add" }, { children: (0, jsx_runtime_1.jsx)(Add_1.default, {}) }))] })));
exports.default = (0, styles_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(ShoppingCartItemQuantity));
//# sourceMappingURL=ShoppingCartItemQuantity.js.map